import { Box } from '@dev-spendesk/grapes';

import { useTranslation } from 'src/core/common/hooks/useTranslation';

export const LoadingQuoteBreakdown = () => {
  const { t } = useTranslation('global');

  return (
    <Box variant="secondary">
      <div className="p-12">
        <p className="body-m">{t('quoteBreakdown.loading')}</p>
      </div>
    </Box>
  );
};
